import { render, staticRenderFns } from "./AboutOneApplicationArea.vue?vue&type=template&id=8064c65e"
import script from "./AboutOneApplicationArea.vue?vue&type=script&lang=js"
export * from "./AboutOneApplicationArea.vue?vue&type=script&lang=js"
import style0 from "./AboutOneApplicationArea.vue?vue&type=style&index=0&id=8064c65e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports